import TableUserData from "./components/tableUserData";

const Users = () => {
  return (
    <TableUserData />
  )
};

export default Users;